import { Component, OnDestroy, OnInit } from '@angular/core';
import { Auth, signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword, Unsubscribe } from '@angular/fire/auth'
import { onAuthStateChanged } from '@angular/fire/auth';
import { Router } from "@angular/router"

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  username: string;
  password: string;

  constructor(public auth: Auth, public router: Router) {

  }

  ngOnDestroy(): void {
  }

  ngOnInit() {
    const unsubscribe = onAuthStateChanged(this.auth, () => {
      if (this.auth.currentUser) {
        this.router.navigate(['/home']);
        unsubscribe();
      }
    });

  }

  async onGoogleLoginButtonClick(): Promise<import("@angular/fire/auth").UserCredential> {
    return await signInWithPopup(this.auth, new GoogleAuthProvider())
  }

  async onLoginButtonClick() {
    return await signInWithEmailAndPassword(this.auth, this.username, this.password);
  }



}
